import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    loginDialogVisible: false,
    path: '',
    tabIndex: 0
  },
  mutations: {
    changeLoginDialogVisible(state, visible) {
      state.loginDialogVisible = visible
    },
    changePath(state, path) {
      state.path = path
    },
    changeTabIndex(state, value) {
      state.tabIndex = value
    }
  },
  actions: {}
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js